import { render, staticRenderFns } from "./JsonItemEditor.vue?vue&type=template&id=ac10e0b0&"
import script from "./JsonItemEditor.vue?vue&type=script&lang=js&"
export * from "./JsonItemEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports